import React from 'react';
import PropTypes from 'prop-types';

import Wizard from '../containers/Modal/Wizard';
import Strings from '../Strings';

export const HEALTH_EVENT_VALUE_MODAL_NAME = 'health-event-value-modal';

export default function HealthEventValueModal({ data }) {
  return (
    <Wizard
      name={HEALTH_EVENT_VALUE_MODAL_NAME}
      pages={[{
        id: 'health-event-value',
        title: Strings.formatString(Strings.healthEventFullValue, data.label),
        content: <pre className="health-event-details-full-value" data-testid="health-event-full-value">{data.value}</pre>,
      }]}
      customButtons={<div className="buttons"><button className="brand-white-gray" type="cancel">{Strings.close}</button></div>}
    />
  );
}

HealthEventValueModal.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
};
